<!--
 * @Author: terrfly
 * @Date: 2020-12-23 09:04:09
 * @LastEditors: terrfly
 * @LastEditTime: 2026-06-24
 * @FilePath: \pay\src\components\ConfirmModal.vue
 * @Description: 自定义确认弹框，替代浏览器原生 alert()，不显示网址
-->
<template>
  <div class="confirm-modal-mask" v-show="visible" @click.self="handleCancel">
    <div class="confirm-modal-box">
      <div class="confirm-modal-content" v-if="title || content">
        <div class="confirm-modal-title" v-if="title" :style="'color:' + typeColor + ';'">{{ title }}</div>
        <div class="confirm-modal-msg" v-if="content">{{ content }}</div>
      </div>
      <div class="confirm-modal-btns">
        <div
          class="confirm-modal-btn confirm-modal-btn-ok"
          :style="'background:' + typeColor + ';border-color:' + typeColor + ';'"
          @click="handleOk"
        >
          {{ okText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmModal",
  data() {
    return {
      visible: false,
      title: "",
      content: "",
      okText: "确定",
      typeColor: "#07c160",
      onOk: null,
      onCancel: null,
    };
  },
  methods: {
    show(options = {}) {
      this.title = options.title || "";
      this.content = options.content || options.message || "";
      this.okText = options.okText || "确定";
      this.typeColor = options.typeColor || this.typeColor;
      this.onOk = typeof options.onOk === "function" ? options.onOk : null;
      this.onCancel =
        typeof options.onCancel === "function" ? options.onCancel : null;
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
      if (this.onOk) this.onOk();
    },
    handleCancel() {
      this.visible = false;
      if (this.onCancel) this.onCancel();
    },
  },
};
</script>
<style lang="css" scoped>
@import './ConfirmModal.css';
</style>
